

import React from 'react'
import { SkyInformationPopover } from './SkyPopover';

export const ClaimFlightLogPopover = (props) => {
  return (
      <SkyInformationPopover eventId={'claim-flight-log'}>
          <div className="text-small">Click to open the Flight Logs FAQ</div>
        </SkyInformationPopover>
  );
}